import { render } from "./lTag.vue?vue&type=template&id=4b288c2a&scoped=true"
import script from "./lTag.vue?vue&type=script&lang=js"
export * from "./lTag.vue?vue&type=script&lang=js"

import "./lTag.vue?vue&type=style&index=0&id=4b288c2a&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b288c2a"]])

export default __exports__